<lazy-echart
    class="chart"
    [class.chart--fixed-height]="hasFixedHeight"
    [options]="chartOptions"
    (chartInit)="setChartHandle($event)"
>
</lazy-echart>
